import i from "styled-components";
import { Base as d } from "./atoms-v2777.js";
import { Text as r } from "./atoms-v243.js";
const a = i.fieldset`
  ${d}

  border: none;
`, f = i(r)`
  ${d}

  display: block;

  && {
    margin-bottom: 12px;
  }
`, u = i.div`
  display: flex;
  flex-direction: column;
`, o = i.div`
  display: flex;
  flex: 0 1 ${({ $span: t }) => t > 0 ? `${t * 100}%` : "auto"};

  & > * {
    flex-grow: 1;
  }
`, n = i.div`
  --radius: ${({ theme: t }) => t == null ? void 0 : t.get("tokens.radius.fieldMedium")}px;

  display: flex;

  & > * {
    flex-grow: 1;
  }

  /* Add radius to the top-left of first field in first row. */
  &:first-child ${o}:first-of-type [data-testid='input-outline'] {
    border-top-left-radius: var(--radius);
  }

  /* Add radius to the top-right of last field in first row. */
  &:first-child ${o}:last-of-type [data-testid='input-outline'] {
    border-top-right-radius: var(--radius);
  }

  /* Add radius to the bottom-left of first field in last row. */
  &:last-child ${o}:first-of-type [data-testid='input-outline'] {
    border-bottom-left-radius: var(--radius);
  }

  /* Add radius to the bottom-right of last field in last row. */
  &:last-child ${o}:last-of-type [data-testid='input-outline'] {
    border-bottom-right-radius: var(--radius);
  }
`;
export {
  u as Fields,
  a as FormGroup,
  o as Input,
  f as Legend,
  n as Row
};
